"use strict";
(self["webpackChunkshop_chunks"] = self["webpackChunkshop_chunks"] || []).push([[255,224],{

/***/ 8255:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Slider)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7475);
/* harmony import */ var _accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_accessible360_accessible_slick__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utilities_functions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5224);






/**
 * * Initializes any Slick sliders using the provided config
 * 
 * @options
    * [data-slick] {required} - Optionally pass a Slick config
    * [data-sync-heights] - Sync slide heights to match tallest slide
 */
function Slider({ wrapper: node }) {
    const $slider = jquery__WEBPACK_IMPORTED_MODULE_0___default()(node);

    ; (function init() {
        // const config = getConfig($slider);

        $slider.slick();

        $slider.find('.slick-slide').on('click', (e) => onSlideClick(e));

        if ($slider.filter('[data-sync-heights]').length) {
            jquery__WEBPACK_IMPORTED_MODULE_0___default()(window).on('resize', () => {
                $slider.slick('setPosition');
            });

            $slider.on('setPosition', () => {
                const $slides = $slider.find('.slick-slide');
                (0,_utilities_functions__WEBPACK_IMPORTED_MODULE_2__.syncElementsHeight)($slides);
            });
        }

        checkForCounter();
    })()

    function checkForCounter() {
        const $section = $slider.closest('.shopify-section');
        const $counter = $section.find('[data-hook="slick-counter"]');

        if (!(0,_utilities_functions__WEBPACK_IMPORTED_MODULE_2__.elementsExist)([$section, $counter])) return;

        $slider.on('beforeChange', function (_, __, ___, slideIndex) {
            $counter.text(slideIndex + 1);
        });
    }

    /**
     * 
     * @param {*} $slider 
     * @returns 
     * 
     * @example
        if ( classList.includes('js-your-custom-class') ) {
            config = {};
        }
     */
    function getConfig($slider) {
        const classNames = $slider.attr('class');
        const classList = classNames?.split(' ');
        let config = null;

        // * Add custom configuration objects here
        // ...

        return config;
    }

    function onSlideClick(event) {
        const $slide = jquery__WEBPACK_IMPORTED_MODULE_0___default()(event.currentTarget);
        const slickIndex = $slide.data('slick-index');
        const $slider = $slide.closest('[data-slick]');

        $slider.slick('slickGoTo', slickIndex);
    }
}


/***/ }),

/***/ 5224:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   elementsExist: () => (/* binding */ elementsExist),
/* harmony export */   formatMoney: () => (/* binding */ formatMoney),
/* harmony export */   isMobile: () => (/* binding */ isMobile),
/* harmony export */   syncElementsHeight: () => (/* binding */ syncElementsHeight),
/* harmony export */   toggleScroll: () => (/* binding */ toggleScroll)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9755);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);



/**
 * * Checks if the given elements exist on the DOM
 *
 * @param  {Object[]} elements - A list of jQuery objects
 * @returns {boolean} Whether the elements were found on the DOM
 */
function elementsExist(elements = []) {
    return elements.filter(el => el.length).length == elements.length;
}


function toggleScroll(dir) {
    const overflowY = document.documentElement.style.overflowY

    if ( dir ) {
        document.documentElement.style.overflowY = dir == '+'
            ? ''
            : 'hidden'
    }
    else {
        document.documentElement.style.overflowY = overflowY == 'hidden'
            ? ''
            : 'hidden'
    }
}


/**
 * * Determines if the current screen is mobile-sized
 *
 * @returns {boolean} Whether the current screen width is within the mobile threshhold
 */
function isMobile() {
    return window.screen.availWidth < parseInt(window.config.screens.md);
}


/**
 *
 * @param {*} cents
 * @param {*} format
 * @returns
 */
function formatMoney(cents, format) {
    if ( typeof cents == 'string' ) cents = cents.replace('.', '');
  
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || '${{ amount_no_decimals }}');
  
    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number / 100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
  
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
  
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
  
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
  
      }
  
    return formatString.replace(placeholderRegex, value);
};


/**
 * Updates a list of elements to all match the height of the tallest element provided
 * 
 * @param {jQuery node list} $elements 
 */
 function syncElementsHeight($elements) {
    if ( !$elements.length ) return;

    // Reset heights to get accurate measurement
    $elements.height('auto');

    // Sort elements by intrinsic height
    const sortedByHeight = $elements.sort((a, b) => {
        return b.offsetHeight - a.offsetHeight;;
    });
    const maxHeight = sortedByHeight[0].offsetHeight;

    // Set all elements to match the tallest element found
    $elements.height(maxHeight);
}


/***/ })

}]);